import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from "react"
import Slider from "react-slick"

import { throttle, isMobile, equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { quanta, isNotEmpty } from  "../../utilities/FrontFunctions/AoxFrontFunctions"
import IconSVG from "../../utilities/FrontFunctions/IconSVG"
import ObjPushThematiqueFormation from './ObjPushThematiqueFormation'

import '../../assets/css/0020_objects/0700_obj_tabs_parcours_formation.css'
import '../../assets/css/0020_objects/0710_obj_carousel_formation.css'

class ObjTabsHomeComptoirDermato extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            toggleState: 1, // État initial
            nbTabs: 0, // Nombre de Tabs
            titleTabs: [],
        }
        this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
        this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
    }
    handleWindowResizeMainHeader() {
        this.setState({
            isMobile: isMobile()
        })
        this.applyEqualHeight()
    }

    componentDidMount() {
        this.setState({
            isMobile: isMobile(),
            toggleState: 1, // État initial
            nbTabs: quanta(this.props.datasSegments), // Nombre de Tabs
            titleTabs: isNotEmpty(this.props.datasSegments) ? this.props.datasSegments.map(o => o.pageTitle.jss.value) : [],
        })
        this.applyEqualHeight();
        window.addEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    applyEqualHeight() {
        setTimeout(() => {
            equalHeight(".obj_tabs_parcours_formation .obj_tabs_content .obj_push_card .ctn_text_card");
        });
    }
    
    toggleTab = (index) => {
        this.setState({ toggleState: index })
        if (index >= 1 && index <= this.state.nbTabs) {
            this.setState({ toggleState: index });
        }
    }

    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

    render() {
        const { toggleState, nbTabs, titleTabs } = this.state
        const { datasSegments } = this.props;

        const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: false,
			infinite: false,
			slidesToShow: 3,
            swipeToSlide: true,
            onSwipe: this.onSwipe.bind(this),
            dots: false,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: true,
            speed: 750,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: "10%",
                        centerMode: true,
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        }

		return (<>{isNotEmpty(datasSegments) && <>
            <div className="obj_tabs_parcours_formation">

                { this.state.isMobile && 
                    <>
                    <div className="obj_navigation_header_formation">
                        <div className="ctn_nav">
                            {/* Bouton gauche */}
                            <button
                                className={`obj_btn_tab_arrow arrow_prev ${toggleState === 1 ? "is_disabled" : ""}`}
                                onClick={() => this.toggleTab(toggleState - 1)}
                                disabled={toggleState === 1}
                            >
                                <IconSVG icon="arrow_left" />
                            </button>
        
                            {/* Titres dynamiques */}
                            <div className="ctn_title">
                                {titleTabs.map((tab, index) => (
                                    <span
                                        key={index}
                                        className={`t_title ${toggleState === index + 1 ? "is_current" : "is_hidden"}`}
                                    >
                                        {tab}
                                    </span>
                                ))}
                            </div>
        
                            {/* Bouton droit */}
                            <button
                                className={`obj_btn_tab_arrow arrow_next ${toggleState === nbTabs ? "is_disabled" : ""}`}
                                onClick={() => this.toggleTab(toggleState + 1)}
                                disabled={toggleState === nbTabs}
                            >
                                <IconSVG icon="arrow_right" />
                            </button>
                        </div>
                    </div>

                    <div className="obj_tabs_list_content">
                        {datasSegments.map((dataSegment, index) => (
                            <div key={index} className={toggleState === index+1 ? "obj_tabs_content is_active" : "obj_tabs_content"} >
                                {isNotEmpty(dataSegment.ListThemeFolder[0]?.ListTheme) && <>
                                    <div className="ctn_title">
                                        <h3 className="t_subtitle">Choisissez une thématique :</h3>
                                    </div>

                                    <Slider {...settings} ref={sliderRef}>
                                        { dataSegment.ListThemeFolder[0].ListTheme.map((datasTheme, index) => (
                                            <div className="item" key={index}>
                                                <ObjPushThematiqueFormation datasTheme={datasTheme}/>
                                            </div>
                                        ))}
                                    </Slider>
                                </>}
                            </div>
                        ))}
                    </div>
                    </>
                }

                {!this.state.isMobile &&
                    <>
                    <div className="obj_tabs_list_tabs">
                        {datasSegments.map((dataSegment, index) => (
                            <button
                                key={index}
                                className={toggleState === index + 1 ? "obj_btn_tab is_active" : "obj_btn_tab"}
                                onClick={() => this.toggleTab(index + 1)}
                            >
                                <span className="t_title">{dataSegment.pageTitle.jss.value}</span>
                            </button>
                        ))}
                    </div>

                    <div className="obj_tabs_list_content">
                        {datasSegments.map((dataSegment, index) => (
                            <div key={index} className={toggleState === index+1 ? "obj_tabs_content is_active" : "obj_tabs_content"} >
                                {isNotEmpty(dataSegment.ListThemeFolder[0]?.ListTheme) && <>
                                    <div className="ctn_title">
                                        <h3 className="t_subtitle">Choisissez une thématique :</h3>
                                    </div>

                                    <div className="ctn_row">
                                        { dataSegment.ListThemeFolder[0].ListTheme.map((datasTheme, index) => (
                                            <ObjPushThematiqueFormation key={index} datasTheme={datasTheme}/>
                                        ))}
                                    </div>
                                </>}
                            </div>
                        ))}
                    </div>
                    </>
                }

            </div>
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(ObjTabsHomeComptoirDermato));